document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') return;

  const carouselElements = document.querySelectorAll('[data-products-carousel]');
  
  const initCarousel = (target) => {
    new Swiper(target, {
      on: {
        init: function (swiper) {
          swiper.el.classList.add('swiper-initialized');
          console.log('Performance: Products Carousel initialized via IntersectionObserver');
        },
      },
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 25,
      pagination: {
        el: target.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: target.querySelector('.swiper-button-next'),
        prevEl: target.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      }
    });
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          initCarousel(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    carouselElements.forEach(el => observer.observe(el));
  } else {
    carouselElements.forEach(el => initCarousel(el));
  }

  // Auto-pause native videos in product cards when not visible
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        if (video.paused) video.play().catch(() => {});
      } else {
        if (!video.paused) video.pause();
      }
    });
  }, { threshold: 0.1 });

  // Observe existing card videos
  document.querySelectorAll('.card-product-video-native-container video').forEach(v => videoObserver.observe(v));

  // Observe dynamically added card videos (infinite scroll, AJAX)
  const mutObs = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          const vids = node.querySelectorAll ? node.querySelectorAll('.card-product-video-native-container video') : [];
          vids.forEach(v => videoObserver.observe(v));
        }
      });
    });
  });
  mutObs.observe(document.body, { childList: true, subtree: true });
});
